import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../utils/useDeleteDebounce'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleTagMutation } from '../../../core/api/TagsApi'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

interface UseDeleteTagsResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteTags = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteTagsResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleTag] = useArchiveMultipleTagMutation()
  const { t } = useTranslation()

  const deleteTagsHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleTag({
        tags: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные тэги успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteTagsHandler,
    extraText: t('Выбранные вами тэги будут удалены!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
